import IotWebSocketClient from './iotWebSocketClient';

export default class IotHolderWebSocketClient extends IotWebSocketClient {
    constructor(assetId, createNew = false, options) {
        super(assetId, createNew, options, 'IotHolderWebSocketClient');
    }
}
